import React from 'react';
import { useSceneViewStore } from '../../store/sceneViewStore';

export const SelectionBox: React.FC = () => {
  const { boxSelection } = useSceneViewStore();

  if (!boxSelection || !boxSelection.isSelecting) {
    return null;
  }

  const { startX, startY, endX, endY } = boxSelection;

  // Calculate rectangle bounds
  const left = Math.min(startX, endX);
  const top = Math.min(startY, endY);
  const width = Math.abs(endX - startX);
  const height = Math.abs(endY - startY);

  // Don't render if box is too small
  if (width < 2 && height < 2) {
    return null;
  }

  return (
    <div
      className="absolute pointer-events-none"
      style={{
        left,
        top,
        width,
        height,
        border: '1px solid rgba(59, 130, 246, 0.8)',
        backgroundColor: 'rgba(59, 130, 246, 0.15)',
        boxShadow: '0 0 8px rgba(59, 130, 246, 0.3)',
      }}
    >
      {/* Corner indicators */}
      <div className="absolute -left-1 -top-1 w-2 h-2 bg-blue-500 rounded-full" />
      <div className="absolute -right-1 -top-1 w-2 h-2 bg-blue-500 rounded-full" />
      <div className="absolute -left-1 -bottom-1 w-2 h-2 bg-blue-500 rounded-full" />
      <div className="absolute -right-1 -bottom-1 w-2 h-2 bg-blue-500 rounded-full" />
    </div>
  );
};
